async function fetchMatrix() {
    // Build query parameters
    const params = new URLSearchParams({
        language: getLanguage()
    });

    try {
        const response = await fetch(`/api/FindFacilityApi/GetFilterModal?${params.toString()}`, {
            headers: {
                'Accept': 'application/json',
            }
        });
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching markers:", error);
        return null;
    }
}
